const environment = (() => {
  if (window.location.origin.indexOf('://localhost:3000') !== -1) {
    return 'local'
  }
  if (window.location.origin.indexOf('://dev') !== -1) {
    return 'development'
  }
  if (window.location.origin.indexOf('://staging') !== -1) {
    return 'staging'
  }
  return 'production'
})()

const config = {
  'baseURL': (() => {
    switch (environment) {
    case 'local':
      return 'http://localhost:8080'
    case 'development':
      return 'https://api.dev.cmonjardinier.com'
    case 'staging':
      return 'https://api.staging.cmonjardinier.com'
    default:
      return 'https://api.v2.cmonjardinier.com'
    }
  })(),
  'gtmArgs': (() => {
    switch (environment) {
    case 'local':
    case 'development':
      return {
        gtmId: 'GTM-MBKG7MLW',
        preview: 'env-10',
        auth: 'N1ZgQZ-PJX3_6BSY54KwoA'
      }
    case 'staging':
      return {
        gtmId: 'GTM-MBKG7MLW',
        preview: 'env-11',
        auth: '7e4xbs3vPkOWhjjNiplgXw'
      }
    default:
      return {
        gtmId: 'GTM-MBKG7MLW',
        preview: 'env-1',
        auth: 'k7hHBCPwh2gLZHb5xKBTAQ'
      }
    }
  })(),
  // Interval to check if refresh is required
  'authentication_refresh_interval': 10000,
  // Refresh will happen if token is about to expire in X seconds
  'authentication_refresh_delta': 60,
  'environment': environment,
  'vendors-activated': ['staging', 'production'].indexOf(environment) !== -1,
  'debug': ['local', 'development'].indexOf(environment) !== -1,
  // Fond de carte CARTO. Sans cle, les tuiles sont filigranees « API KEY REQUIRED ».
  // Palier gratuit : 5 M de tuiles/mois. Cle a generer sur carto.com.
  'carto-key': 'cb1_2su5_1_0b9e24f36c9cf10f8348d5c6',
  'zendesk-key': '52qpB9usHRe7t1ZLo9sD1JWPQzdgRgQK',
  'usersnap-active': environment === 'heroku',
  'usersnap-key': (() => {
    switch (environment) {
    case 'staging':
      return '75bf5edf-cfa8-4c87-9aba-c13e122ce25f'
    default:
      return '83a2a634-1e83-4b49-bc0d-3f954a2994c7'
    }
  })(),
  'hotjar-id': '1872222',
  'hotjar-version': '6',
  'apiURL': '/api/v1/',
  'oauthURL': '/oauth',
  'oauth_app_id': 'atoutjardinapp',
  'oauth_app_secret': 'my-secret-token-to-change-in-production',
  'paginate_size': '500',
  'customers': 'customers',
  'professionals': 'professionals',
  'profile_image_default': '/app/images/photo_jardinier_detail_empty.png',
  'max_garderners_bullets_images': 10,
  // Notes affichees sur les cards (proxy backend -> Skeepers)
  'ratings_bulk_chunk_size': 50,
  'ratings_timeout': 2000,

  'homepage_url': (() => {
    switch (environment) {
    case 'local':
      return 'https://dev.cmonjardinier.com'
    case 'development':
      return 'https://dev.cmonjardinier.com'
    case 'staging':
      return 'https://staging.cmonjardinier.com'
    default:
      return 'https://www.cmonjardinier.com'
    }
  })(),

  'cgu_url': 'https://www.cmonjardinier.com/cgu'
}

export default config



// WEBPACK FOOTER //
// ./src/config.js